import { render, staticRenderFns } from "./AdminLicenseMaster.vue?vue&type=template&id=6622383c&scoped=true&"
import script from "./AdminLicenseMaster.vue?vue&type=script&lang=js&"
export * from "./AdminLicenseMaster.vue?vue&type=script&lang=js&"
import style0 from "./AdminLicenseMaster.vue?vue&type=style&index=0&id=6622383c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6622383c",
  null
  
)

export default component.exports